<template>
    <div class="meta-if-post">
        <!-- <div class="meta-if-post__avatar">Instagram</div> -->

        <div class="meta-if-post__header">
            <div class="meta-if-post__user-info">
                <div class="meta-if-post__user-name">Business Name</div>
                <div class="meta-if-post__sponsored">Sponsored</div>
            </div>
            <div class="meta-if-post__options">⋯</div>
        </div>

        <div class="meta-if-post__content">
            <slot />
        </div>

        <div class="meta-if-post__cta">
            <button v-if="metaOverwrites?.fbCallToAction" class="meta-if-post__cta-btn">
                {{ metaOverwrites.fbCallToAction }}
                <span>&#10095;</span>
            </button>
        </div>

        <div class="meta-if-post__divider" />

        <div class="meta-if-post__actions">
            <Icon type="ios-heart-outline" />
            <Icon type="ios-chatbubbles-outline" />
            <Icon type="ios-send-outline" />
            <Icon type="ios-bookmark-outline" />
        </div>

        <div v-if="metaOverwrites?.fbPrimaryText" class="meta-if-post__text">
            {{ metaOverwrites?.fbPrimaryText }}
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { MasterTemplate } from "shared-types";

import { AdSubType } from "@/enums/assemble";
import type { MetaOverwrites } from "@/types/types";

export default defineComponent({
    name: "InstagramFeed",
    props: {
        metaOverwrites: {
            type: Object as PropType<MetaOverwrites>,
            default: () => ({})
        },

        adSubType: {
            type: String as PropType<(typeof AdSubType)[keyof typeof AdSubType]>,
            default: AdSubType.Video
        },

        masterTemplate: {
            type: Object as PropType<MasterTemplate>
        },

        adSize: {
            type: Number
        }
    }
});
</script>

<style lang="scss" scoped>
.meta-if-post {
    background-color: #fff;
    border-top: 1px solid #ccd0d5;
    border-bottom: 1px solid #ccd0d5;

    flex: 1;

    display: flex;
    flex-direction: column;
}

.meta-if-post__header {
    height: 64px;

    padding: 12px 16px;

    display: flex;
}

.meta-if-post__user-info {
    flex: 1;

    .meta-if-post__user-name {
        font-weight: bold;
        font-size: 14px;
    }

    .meta-if-post__sponsored {
        font-weight: normal;
        font-size: 12px;
        color: #606770;
    }

    .meta-if-post__time {
        font-size: 12px;
    }

    .meta-if-post__options {
        font-size: 24px;
        color: #606770;
        cursor: pointer;
    }
}

.meta-if-post__content {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.meta-if-post__cta {
    display: flex;
    padding: 0 16px;

    .meta-if-post__cta-btn {
        flex-grow: unset;
        margin: auto 0 auto auto;
        display: flex;
        border-radius: 4px;
        border: 0;
        padding: 5px 0;
        width: 100%;
        background: none;
        font-weight: 600;
        font-size: 12px;
        color: #000;
        text-align: left;

        span {
            display: inline-block;
            margin-left: auto;
        }
    }
}

.meta-if-post__divider {
    height: 1px;
    background-color: #dddfe2;
}

.meta-if-post__actions {
    padding: 8px 12px;

    display: flex;
    gap: 10px;
    justify-content: space-around;
    color: #606770;
    font-size: 14px;
    i {
        font-size: 29px;
        color: #000;
        font-weight: 600;
        &:last-child {
            margin-left: auto;
        }
    }
}

.meta-if-post__text {
    font-size: 12px;
    padding: 8px 12px;
}
</style>
